var exports = {
  "ci": "TextareaInput.module__textareaContainer___V0tsX0",
  "yF": "TextareaInput.module__divider___V0tsX0",
  "Ot": "TextareaInput.module__textareaOuter___V0tsX0",
  "WJ": "TextareaInput.module__collapsibleSection___V0tsX0",
  "qp": "TextareaInput.module__inputSection___V0tsX0",
  "aq": "TextareaInput.module__textareaOuterMobile___V0tsX0",
  "AE": "TextareaInput.module__mainWrapperDense___V0tsX0",
  "bx": "TextareaInput.module__mainWrapperEditing___V0tsX0",
  "m$": "TextareaInput.module__uploadButtonColumn___V0tsX0",
  "D4": "TextareaInput.module__sideButtonPadding___V0tsX0",
  "Qh": "TextareaInput.module__plusButtonAboveBackdrop___V0tsX0",
  "Sr": "TextareaInput.module__contentAreaDense___V0tsX0",
  "h": "TextareaInput.module__contentAreaEditing___V0tsX0",
  "l7": "TextareaInput.module__buttonContainerDense___V0tsX0",
  "ae": "TextareaInput.module__buttonContainerEditing___V0tsX0",
  "ou": "TextareaInput.module__textareaOuterRow___V0tsX0",
  "o_": "TextareaInput.module__textareaOuterBare___V0tsX0",
  "nw": "TextareaInput.module__mainWrapperBare___V0tsX0",
};

module.exports = exports;
